type PdfPreviewSkeletonProps = {
  numPages?: number;
};

export const PdfPreviewSkeleton = ({
  numPages = 4,
}: PdfPreviewSkeletonProps) => (
  <div className="flex w-full flex-col items-center gap-1 px-4 py-4">
    {Array.from({ length: numPages }).map((_, i) => (
      <div
        key={`pdf-skeleton-${i}`}
        className={`
          h-[min(70vh,520px)] w-full animate-pulse rounded-md bg-base-secondary
        `}
      />
    ))}
  </div>
);
